//@flow
import { styled } from 'linaria/react';
export const Button =
/*#__PURE__*/
styled("button")({
  name: "Button",
  class: "b14mo28h"
});
export const SharedUrl =
/*#__PURE__*/
styled("input")({
  name: "SharedUrl",
  class: "s1k8xbfh"
});
export const ShareButton =
/*#__PURE__*/
styled(Button)({
  name: "ShareButton",
  class: "sfloqf4"
});
export const ShareGroup =
/*#__PURE__*/
styled("div")({
  name: "ShareGroup",
  class: "s98uqpp"
});